import React from 'react';
import CustomSlider from "./CustomSlider";
import IconCard from './IconCard';
import { styled } from "../../../stitches.config";
import { useWindowWidth } from '../../../helpers';
import { bodyLarge, h2 } from '../../commonStyles/Fonts';

import { ReactComponent as DotsOrange } from '../../../redesign/assets/icons/dots-orange-icon.svg?react';

import { ReactComponent as DzialHrIcon } from '../../../assets/img/natemat/career/w_redakcji_jako_dziennikarz.svg?react';
import { ReactComponent as DzialKreatywnyIcon } from '../../../assets/img/natemat/career/dzial_kreatywny.svg?react';
import { ReactComponent as BiuroReklamyIcon } from '../../../assets/img/natemat/career/biuro_reklamy.svg?react';
import { ReactComponent as DzialProdukcjiIcon } from '../../../assets/img/natemat/career/dzial_produkcji_ICP.svg?react';
import { ReactComponent as DzialWideoIcon } from '../../../assets/img/natemat/career/dzial_video.svg?react';
import { ReactComponent as DzialAdopsIcon } from '../../../assets/img/natemat/career/w_redakcji_jako_dziennikarz.svg?react';
import { ReactComponent as DzialSmIcon } from '../../../assets/img/natemat/career/dzial_sm.svg?react';

type IconCardTypes = {
    title: string,
    text: string,
    icon: JSX.Element,
}

const IconCards: IconCardTypes[] = [
    {
        title: 'Redakcje',
        icon: <DzialAdopsIcon />,
        text: "Serce naszej firmy. To w newsroomie pracują dziennikarze naszych wszystkich portali. Tutaj możesz być reporterem, wydawcą, autorem, a także szefem zespołu. Sky’s the limit."
    },
    {
        title: 'Dział produkcji ICP',
        icon: <DzialProdukcjiIcon />,
        text: "Dla nich nie ma rzeczy niemożliwych. W ICP produkujemy wszystko, co wymaga realizacji. Piszemy, nagrywamy, organizujemy sesje zdjęciowe, nagrania wideo. Ściśle współpracujemy z klientami i wszystkimi działami w firmie."
    },
    {
        title: 'Dział wideo',
        icon: <DzialWideoIcon />,
        text: "Nagrywamy, montujemy, reżyserujemy, produkujemy, emitujemy, a czasami nawet też „budujemy”. Sporo też jeździmy w poszukiwaniu najlepszych historii. Jeśli masz doświadczenie w produkcji wideo lub chcesz je zdobyć, to miejsce dla Ciebie."
    },
    {
        title: 'Dział kreatywny',
        icon: <DzialKreatywnyIcon />,
        text: "Działamy na styku wszystkich działów w firmie, a także współpracujemy z klientami. Wymyślamy wyjątkowe kampanie reklamowe i specjalne akcje redakcyjne. A potem ściśle współpracujemy przy ich realizacji, jako project managerowie i graficy."
    },
    {
        title: 'Biuro reklamy',
        icon: <BiuroReklamyIcon />,
        text: "Współpracujemy bezpośrednio z klientami, domami mediowymi i agencjami reklamowymi. To tutaj wymyślamy i sprzedajemy nasze kampanie reklamowe."
    },
    {
        title: 'Dział social media',
        icon: <DzialSmIcon />,
        text: "Grupa naTemat to nie tylko portale. Nasz dział social media dba o obecność naszych marek na wszystkich istotnych portalach społecznościowych. Posty, obróbka graficzna, relacje live, wideo, kontakt z partnerami – to nasza codzienność."
    },
    {
        title: 'Dział AdOps',
        icon: <DzialAdopsIcon />,
        text: "To tutaj optymalizujemy naszą siatkę reklamową i obsługujemy kampanie programatyczne. Siedzenie w cyferkach, analiza danych i technikalia to nasza codzienność."
    },
    {
        title: 'Administracja / HR',
        icon: <DzialHrIcon />,
        text: 'Dba o to, by wszystko działało u nas jak w zegarku. Zarówno od strony formalnej, jak i użytkowej.'
    }
]

const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 996,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
            },
        }
    ]
};

const Positions = ({ scroll }: any) => {

    const isDesktop = useWindowWidth() > 996;

    return (
        <PositionsContainer>
            <PositionsHeading>
                <h2 className={h2()}><DotsOrange /> Gdzie możesz pracować? </h2>
                <p className={bodyLarge()} style={{ display: isDesktop ? 'block' : 'none' }}><OrangeSpan onClick={scroll}>Sprawdź aktualne rekrutacje</OrangeSpan></p>
            </PositionsHeading>
            <PositionsWrapper>
                <CustomSlider {...settings} className='positions-slider'>
                    {
                        IconCards.map((item, index) => {
                            return (
                                <IconCard text={item.text} title={item.title} key={index}>
                                    {item.icon}
                                </IconCard>
                            )
                        })
                    }
                </CustomSlider>
            </PositionsWrapper>
        </PositionsContainer>
    )
}

export default Positions;

const PositionsContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '24px',
    color: '$grayscale100',
    width: '90%',
    boxSizing: 'border-box',
})


const PositionsHeading = styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px',
    'h2': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    '@bp4': {
        alignItems: 'center',
        padding: '15px',
        'h2': {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        },
        'p': {
            color: '$natematPrimary',
            cursor: 'pointer',
        }
    }
})

const PositionsWrapper = styled('div', {
    width: '100%',
    '.positions-slider': {
        '.slick-slider': {
            '.slick-list': {
                overflow: 'visible',
                '.slick-track': {
                    display: 'flex',
                    gap: '8px',
                    '.slick-slide': {
                        height: 'auto',
                        'div': {
                            display: "flex",
                            height: '100%',
                        },
                        '&[aria-hidden="true"]': {
                            opacity: 0.5,
                        },
                    },
                },
            },
            'ul': {
                transform: 'translateY(38px)',
                'li': {
                    background: '$grayscale100',
                    borderRadius: '50%',
                    width: '10px',
                    height: '10px',
                    opacity: 0.1,
                    '&.slick-active': {
                        background: '$natematPrimary',
                        opacity: 1,
                        'button': {
                            '&:before': {
                                content: ''
                            },
                        },
                    },
                },
            },
            '.slick-arrow': {
                display: 'none',
            },
        },

        '@bp4': {
            '.slick-slider': {
                '.slick-list': {
                    '.slick-track': {
                        gap: '16px',
                        '.slick-slide': {
                            height: 'auto',
                            'div': {
                                display: "flex",
                                height: '100%',
                            }
                        }
                    },
                },
                '.slick-next': {
                    display: 'block',
                    background: '$natematPrimary',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    zIndex: 100,
                    transform: 'rotate(90deg) translateX(-25px)',
                    '&::before': {
                        content: '',
                    },
                    '&:hover': {
                        cursor: 'pointer',
                        background: '$natematPrimary',
                    },
                    'svg': {
                        transform: 'translate(50%,50%)',
                        path: {
                            fill: '$grayscale0',
                        }
                    }
                },
                '.slick-prev': {
                    display: 'block',
                    background: '$natematPrimary',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    zIndex: 100,
                    transform: 'rotate(-90deg) translateX(25px)',
                    '&::before': {
                        content: '',
                    },
                    '&:hover': {
                        cursor: 'pointer',
                        background: '$natematPrimary',
                    },
                    'svg': {
                        transform: 'translate(50%,50%)',
                        path: {
                            fill: '$grayscale0',
                        }
                    }
                },
                '.slick-disabled': {
                    display: 'none',
                }
            },
        }
    }
})

const OrangeSpan = styled('span', {
    'a': {
        color: '$natematPrimary',
        textDecoration: 'underline',
    }
})